// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body{font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,Oxygen-Sans,Ubuntu,Cantarell,\"Helvetica Neue\",sans-serif;margin:0}.default-background,body{background-color:#f8f8f8}body.block-scroll{overflow:hidden}.app{height:100%}.section{font-size:1.3rem}.router-link-active{color:red}.img-responsive{max-width:100%;max-height:100%}.a-hover-black:hover{color:#000!important}", ""]);
// Exports
module.exports = exports;
